/*!* Global JS  v13.08.24:01*/
import { tns } from "tiny-slider"
import { getDynamicMenuResponse } from '../opus2/util/getDynamicMenu';
import { getCampaignName, getBrandDetailsFromBrandJson, isOperationActiveNow, isNegative, removeElementEventListeners } from "../opus2/util/share";
import { ScreenType } from "../opus2/location-search-map/models/ScreenType";
import { reportScreenSize } from "../opus2/location-search-map/reportScreenSize";
import { getMessagesData } from "../opus2/util/siteConfig";
import { isTouchDevice } from "../opus2/util/device-detection";
import { attachEventListenerForClaim } from "../opus2/util/coupons-event-handling";
import { getDisplayPhoneNumber } from "../opus2/util/localizationService";
import apiRequest from "../opus2/api/apiRequest";

export class StickyHeader {
    private firstHead: HTMLElement | null;
    private headerH: number;
    public dynamicMenuType: string;
    private readonly headerAlert: HTMLElement | null;
    constructor() {
        this.firstHead = document.querySelector(".first-head");
        const secondHead: HTMLElement | null = document.querySelector(".second-head");
        let findLocalMobile = document.querySelector(".find-local-mobile") as HTMLElement;
        this.headerH = secondHead?.offsetHeight ?? 0;
        this.dynamicMenuType = '';
        this.headerAlert = document.getElementById('header-alert');



        const pageType = (document.getElementById('pageType') as HTMLInputElement)?.value;

        if ((pageType !== 'Opus 2 Lead Flow Template') && (pageType !== 'Opus 2 Onverity-IMS Lead Flow') && (pageType !== 'Opus 2 HMS Lead Flow Template') && (pageType !== 'Opus 2 MLY Lead Flow Template') && (pageType !== 'Opus 2 Agnostic Lead Flow Template')) {

            if (secondHead) {
                this.checkToToggleLogoAndLocationFromStickyHeader(secondHead);
            }
        }

        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        getBrandDetailsFromBrandJson(conceptCode)
            .then(brandData => {
                // Sticky footer js
                this.stickyHeader(brandData);

            }).catch(error => {
                // Handle any errors here
                console.error('Error fetching brand data:', error);
                this.stickyHeader({});
            });




        //FOR SITEMAP TARGET LINK
        const allElements = document.querySelectorAll('.link-target');
        allElements?.forEach((element: any) => {
            element.style.scrollMarginTop = this.headerH - 30 + "px";
        });

        setTimeout(() => {
            this.megaMenu.call(this);
        }, 1000);
        this.readDynamicMenu();

        getCampaignName();
    }

     getSecondHeadHeight() {
        const secondHead: HTMLElement | null = document.querySelector(".second-head");
        return secondHead?.offsetHeight;
      }

      getHeaderHeight() {
        if(!this.headerAlert?.classList.contains('hidden')){
            return (this.headerAlert?.offsetHeight ?? 0) + (this.firstHead?.offsetHeight ?? 0);
        }
        return this.firstHead?.offsetHeight ?? 0;
      }

    //Sticky Header
    public stickyHeader(brandData: any) {
        const secondHead: HTMLElement | null = document.querySelector(".second-head");
        let footerSticky = document.querySelector(".sticky-footer")as HTMLElement;
        let footerMain = document.getElementById("footer");
        let dbaName = localStorage.getItem('dbaName');
        let theHeightofMenuNew: any;
        let theHeightofMenu: any;
        let findLocalMobile = document.querySelector(".find-local-mobile") as HTMLElement;
        let mobileMenuLogo = document.querySelector(".second-head .mobile-menu-logo") as HTMLImageElement;
        let headerCtaMobile = document.querySelector(".second-head .header-cta-mobile") as HTMLElement;
        if (mobileMenuLogo) {
            theHeightofMenu = mobileMenuLogo.offsetHeight;
        }
        if (mobileMenuLogo && headerCtaMobile && findLocalMobile) {
            theHeightofMenuNew = mobileMenuLogo.offsetHeight + headerCtaMobile.offsetHeight + findLocalMobile.offsetHeight;
        }
        const headerElement = document.querySelector(".second-head") as HTMLElement;
        const faqULElements = document.querySelectorAll<HTMLElement>(".accordion-icon-list");
        faqULElements.forEach((faqElement) => {
            faqElement?.addEventListener('click', (event: any) => {
                let headerOffset = headerElement?.offsetHeight;
                const faqBtn = (event.target as HTMLElement).closest(".card-list") as HTMLElement;
                if (event.target && faqBtn) {
                    const faqFormPosition = faqBtn.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = faqFormPosition - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });

        const bookYourInspection = document.querySelector<HTMLElement>(".secondary-btn");
        if(bookYourInspection?.getAttribute('href')?.includes("#short-form-req-name")){
            bookYourInspection?.addEventListener('click', (event)=>{
                event.preventDefault();
                let headerOffset = headerElement?.offsetHeight;
                const shortForm = document.querySelector(".short-form-component");
                if(shortForm){
                    const shortFormPosition = shortForm.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = shortFormPosition - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        }
        let lastScrollTop = 0; 
        let ticking = false;
        
        window.addEventListener("scroll", () => {
            const currentScrollTop = window.scrollY;
            const sticky = secondHead?.offsetTop ?? 0;

            if (!ticking) {
                window.requestAnimationFrame(() => {            
                  if ((footerSticky && window.innerWidth < 1024) && (brandData?.enable_sticky_footer_national && !dbaName || brandData?.enable_sticky_footer_local && dbaName)) {
                    if (!isNegative(lastScrollTop) && currentScrollTop > lastScrollTop) {  // Scrolling Down
                      // Hide sticky header, show sticky footer
                      if (secondHead?.classList.contains("sticky-head")) {
                        secondHead?.classList.add("hidden"); // Hide sticky header
                        if (footerSticky) {
                          footerSticky?.classList.add("footer-fixed"); // Show sticky footer
                          footerSticky?.classList.remove("hidden");
                        }
                        if (footerMain) {
                            footerMain.style.paddingBottom = footerSticky?.offsetHeight + "px"; // Adjust footer space
                        }
                      }
                    } else if (currentScrollTop < lastScrollTop || (isNegative(lastScrollTop))) {  // Scrolling Up
                        // Show sticky header, hide sticky footer
                        if (secondHead?.classList.contains("sticky-head")) {
                            secondHead?.classList.remove("hidden"); // Show sticky header
                            if (footerSticky) {
                                footerSticky?.classList.remove("footer-fixed"); // Hide sticky footer
                                footerSticky?.classList.add("hidden"); 
                            }
                            if (footerMain) {
                                footerMain.style.paddingBottom = "0px"; // Remove footer space
                            }
                        }
                    }
                  }
                  lastScrollTop = window.scrollY;
                  ticking = false;
                });
                ticking = true;
            }
            const main = document.getElementById("main");
            if (window.innerWidth < 1024 && secondHead?.classList.contains("sticky-head") && !secondHead?.classList.contains("hide-find-local")) {
                
                if (window.scrollY > theHeightofMenu) {
                    this.firstHead?.classList.add("hidden");
                    secondHead?.classList.remove("relative");
                    secondHead?.classList.add("fixed", "top-0");
                    if(main){
                        main.style.marginTop = this.getSecondHeadHeight() + "px";
                    }

                } else {
                    this.firstHead?.classList.remove("hidden");
                    secondHead?.classList.remove("fixed", "top-0");
                    secondHead?.classList.add("relative");
                    if(main){
                        main.style.marginTop = "0";
                    }
                }
            }

            if (window.innerWidth < 1024 && secondHead?.classList.contains("hide-find-local") && !secondHead?.classList.contains("sticky-head")) {
                
                if (window.scrollY > theHeightofMenu) {
                    this.firstHead?.classList.add("hidden");
                    secondHead?.classList.remove("relative");
                    secondHead?.classList.add("fixed", "top-0");
                    if(main){
                        main.style.marginTop = this.getSecondHeadHeight() + "px";
                    }
                    findLocalMobile.style.display = "none";
                } else {
                    this.firstHead?.classList.remove("hidden");
                    secondHead?.classList.remove("fixed", "top-0");
                    secondHead?.classList.add("relative");
                    if(main){
                        main.style.marginTop = "0";
                    }
                    findLocalMobile.style.display = "flex";
                }
            }
            if (window.innerWidth < 1024 && secondHead?.classList.contains("hide-find-local") && secondHead?.classList.contains("sticky-head")) {
                if (window.scrollY > theHeightofMenuNew) {
                    this.firstHead?.classList.add("hidden");
                    secondHead?.classList.remove("relative");
                    secondHead?.classList.add("fixed", "top-0");
                    if(main){
                        main.style.marginTop = this.getSecondHeadHeight() + "px";
                    }
                    findLocalMobile.style.display = "none";
                } else {
                    this.firstHead?.classList.remove("hidden");
                    secondHead?.classList.remove("fixed", "top-0");
                    secondHead?.classList.add("relative");
                    if(main){
                        main.style.marginTop = "0";
                    }
                    findLocalMobile.style.display = "flex";
                }
            }
            if (!secondHead?.classList.contains("hide-find-local") && !secondHead?.classList.contains("sticky-head")) {
                if (window.scrollY > sticky) {
                    this.firstHead?.classList.add("hidden");
                    secondHead?.classList.remove("relative");
                    secondHead?.classList.add("fixed", "top-0");
                    if(main){
                        main.style.marginTop = this.getSecondHeadHeight() + "px";
                    }
                    
                } else {
                    this.firstHead?.classList.remove("hidden");
                    secondHead?.classList.remove("fixed", "top-0");
                    secondHead?.classList.add("relative");
                    if(main){
                        main.style.marginTop = "0";
                    }
                    
                }
            }
            if (window.innerWidth > 1024) {
                if (window.scrollY  > this.getHeaderHeight()) {
                    this.firstHead?.classList.add("hidden");
                    secondHead?.classList.remove("relative");
                    secondHead?.classList.add("fixed", "top-0");
                    if(main){
                        main.style.marginTop = this.getSecondHeadHeight() + "px";
                    }
                    
                } else {
                    this.firstHead?.classList.remove("hidden");
                    secondHead?.classList.remove("fixed", "top-0");
                    secondHead?.classList.add("relative");
                    if(main){
                        main.style.marginTop = "0";
                    }
                    
                }
            }
              
            
          });
    }

    async readDynamicMenu() {
        try{
            let response = await getDynamicMenuResponse();
            this.dynamicMenuType = response?.dynamicMenuType;
            this.dynamicMenuV2();
            dynamicMenuV4(response);
            this.initializeSubmegaTabs();
        }
        catch(e){
            console.warn("Error Fetching dynamic menu")
        }
        await addLocalizationHeaderMenuLocal();
    }
    initializeSubmegaTabs(): void {
        const menuContainer = document.querySelector(".dynamic-service-menu")?.closest("ul");
    
        if (!menuContainer) {
            console.error("No parent <ul> found for '.dynamic-service-menu'.");
            return;
        }
    
        menuContainer.addEventListener("click", function (event: Event) {
            const targetElement = (event.target as HTMLElement).closest<HTMLButtonElement>(".submega-tab-button");
    
            if (!targetElement) return;
    
            const targetId = targetElement.getAttribute("data-tabs-target");
    
            if (!targetId) {
                console.error("No target ID found for button:", targetElement);
                return;
            }
    
            const targetContent = document.querySelector<HTMLElement>(targetId);
    
            if (!targetContent) {
                console.error("No target element found for selector:", targetId);
                return;
            }
    
            const tabContentContainer = document.querySelector(".submega-tab-content");
    
            if (!tabContentContainer) {
                console.error("No '.submega-tab-content' container found.");
                return;
            }
    
            // Hide all tab content
            document.querySelectorAll<HTMLElement>(".submega-tab-content > div").forEach(content => {

                content.classList.add("hidden");
            });

            // Reset all buttons' aria-selected
            document.querySelectorAll<HTMLButtonElement>(".submega-tab-button").forEach(btn => {
                btn.setAttribute("aria-selected", "false");
            });
    
            // Show selected tab content and update aria-selected
            targetContent.classList.remove("hidden");
            targetElement.setAttribute("aria-selected", "true");
        });
    }
    
    megaMenu() {
        // MEGA MENU JS STARTS HERE
        const firstMenu = document.querySelector<HTMLElement>(".mega-menu");
        const secondMenu = document.querySelector<HTMLElement>(".sub-menu");
        const theMenuButton: any = document.querySelector<HTMLElement>(".mobile-sidebar-drawer");
        const showMenu = document.querySelectorAll<HTMLElement>(".expand-menu-js");

        const mainMenu = document.querySelectorAll<HTMLElement>('.nav-link');

        if (window.matchMedia("(max-width: 1023px)").matches) {
            theMenuButton?.setAttribute("data-drawer-target", "sidebar");
            theMenuButton?.setAttribute("data-drawer-toggle", "sidebar");
            theMenuButton?.setAttribute("data-drawer-backdrop","false");
        }

        mainMenu?.forEach(main => {
            const screenType = reportScreenSize();
            if (screenType !== ScreenType.Desktop) {
                main.addEventListener('click', function handleClick(event) {
                    let id: any = this.getAttribute('data-nested-value');
                    let idWrap = document.getElementById(id);
                    idWrap?.classList.add('show-menu');
                    idWrap?.classList.remove('hide-menu');
                });
            }
        });

        const backBtn = document.querySelectorAll<HTMLElement>('.back-btn');
        backBtn?.forEach(back => {
            back.addEventListener('click', function handleClick(event) {
                let nameBack: any = this.getAttribute('data-back');
                let idWrap = document.getElementById(nameBack);
                idWrap?.classList.remove('show-menu');
                idWrap?.classList.add('hide-Submenu');
            });
        });

        const backTabBtn = document.querySelectorAll<HTMLElement>('.back-tab-btn');
        backTabBtn?.forEach(back => {
            back.addEventListener('click', function handleClick(event) {
                back.closest(".mega-menu")?.querySelector(".tab-sibling")?.classList.remove('hide-menu');
                let nameBack: any = this.getAttribute('data-back');
                let idWrap = document.getElementById(nameBack);
                idWrap?.classList.remove('show-menu');
                idWrap?.classList.add('hidden');
            });
        });

        const closeNav = document.querySelector<HTMLElement>(".sidenav-close");
        closeNav?.addEventListener('click', closeAllMenu);
        let allFirstMenu = document.querySelectorAll<HTMLElement>(".mega-menu");
        let allSecondMenu = document.querySelectorAll<HTMLElement>(".sub-menu");

        function closeAllMenu() {
            allFirstMenu.forEach((element) => {
                element?.classList.remove('show-menu');
            });
            allSecondMenu.forEach((element) => {
                element?.classList.add('hide-Submenu');
            });
            document.querySelector<HTMLElement>(".tab-sibling")?.classList.remove('hide-menu');

            // Remove dynamic 4 menu
            const dynamicMenuWrap = document.querySelector(".dynamic-menu-wrap");
            if (dynamicMenuWrap) {
                dynamicMenuWrap.classList.add('hide-menu');
                dynamicMenuWrap.classList.remove('show-menu');
            }

            const subMenus = document.querySelectorAll('.new-submenu-inner-warp > div');
            if (subMenus.length > 0) {
                subMenus.forEach((subMenu: Element) => {
                    subMenu.classList.add('hide-menu');
                    subMenu.classList.remove('show-menu');
                });
            }
        }

        const slideBlock = document.querySelector<HTMLElement>(".slide-block");
        const brandHeader = document.querySelector<HTMLElement>(".main-nav-warpper");
        const slideBlockH: any = slideBlock?.offsetHeight;
        const brandHeaderH = brandHeader?.offsetHeight;
        const firstMenuTop = document.querySelectorAll<HTMLElement>(".mega-menu");
        const firstSubMenuTop = document.querySelectorAll<HTMLElement>(".sub-menu");

        const mql = window.matchMedia("(max-width: 1023px)");

        if (mql.matches) {
            firstMenuTop.forEach((element: any) => {
                element.style.top = slideBlockH + 16 + "px";
            });
            firstSubMenuTop.forEach((element: any) => {
                element.style.top = "0";
            });
        }

        // RESET SUBMEGAMENU ON MOUSE LEAVE
        const subMegaMenu: any = document.getElementsByClassName('submega-inner-warp');
        if (window.matchMedia("(min-width:1024px)").matches) {
            for (let i = 0; i < subMegaMenu.length; i++) {
                subMegaMenu[i].onmouseleave = function () {
                    document.getElementsByClassName("mega-inner-warp tab-sibling")[i].classList.remove('hide-menu');
                    document.querySelectorAll(".submega-inner-warp")[i].classList.remove('show-menu');
                    document.querySelectorAll(".submega-inner-warp")[i].classList.add('hide-menu');
                    const hideSubMegaMenu = document.querySelectorAll('.submega-tab-content div[role="tabpanel"]');
                    hideSubMegaMenu.forEach(item => {
                        item.classList.add('hidden');
                    })
                    let resetMenuBtn: any = document.querySelectorAll('.submega-tab li[role="presentation"] button');
                    resetMenuBtn?.forEach((item: any) => {
                        item.setAttribute("aria-selected", "false");
                    })
                }
            }
        }

    }

    async checkToToggleLogoAndLocationFromStickyHeader(menuDOM: HTMLElement) {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        if (brandData) {

            //remove logo from sticky header
            if (brandData.disable_stickyheader_logo) {
                menuDOM.classList.add("sticky-head")
            }
            else {
                menuDOM.classList.remove("sticky-head")
            }

            //remove find my location from sticky header
            if (brandData.disable_findmylocations) {
                menuDOM.classList.add("hide-find-local")
            }
            else {
                menuDOM.classList.remove("hide-find-local")
            }
        }
    }

    public dynamicMenuV2() {

        const mainSubMenu = document.querySelectorAll<HTMLElement>('.expand-menu-js');
        this.dynamicMenuType = this.dynamicMenuType?.replace(/\s/g, "")?.toLowerCase();
        const dynamicStr = 'Dynamic Menu V2'.replace(/\s/g, "").toLowerCase();
        if (this.dynamicMenuType == dynamicStr) {
            mainSubMenu?.forEach(main => {
                main.addEventListener('click', function handleClick(event) {
                    try {
                        if (main.closest(".dynamic-service-menu .tab-sibling")) {
                            main.closest(".dynamic-service-menu .tab-sibling")?.classList.add('hide-menu');
                        }
                        
                        let id: any = this.getAttribute('data-nested-value');
                        let tab: any = this.getAttribute('data-active-tab');
                        let idWrap = document.getElementById(id);
                        idWrap?.classList.add('show-menu');
                        idWrap?.classList.remove('hide-menu');

                        let idTab = document.getElementById(tab);
                        idTab?.closest(".submega-tab")?.querySelector(".submega-tab-button")?.setAttribute("aria-selected", "false");
                        idTab?.setAttribute("aria-selected", "true");

                        let openTab = idTab?.getAttribute("data-tabs-target");
                        let tabIdsArray: any = openTab?.split("#");

                        if (tabIdsArray && tabIdsArray.length > 0) {

                            let idTabCont = document.getElementById(tabIdsArray[1]);
                            idTabCont?.closest(".submega-inner-warp")?.querySelector(".submega-tab-content div[role='tabpanel']")?.classList.add('hidden');
                            idTabCont?.classList.remove('hidden');

                        }
                    } catch (error) {
                        console.error("An error occurred in the click event:", error);
                    }
                });
            });
        }
    }

}

class AsideDiv {
    private aside: HTMLElement | null;
    private secondHead: HTMLElement | null;
    private headerH: number;

    constructor() {
        this.secondHead = document.querySelector(".second-head");
        this.aside = document.querySelector(".blog-aside");
        this.headerH = this.secondHead?.offsetHeight || 0;
        if (this.aside) {
            this.aside.style.top = this.headerH - 64 + "px";;
        }

        //FOR SITEMAP TARGET LINK
        const allElements = document.querySelectorAll('.link-target');
        allElements?.forEach((element: any) => {
            element.style.scrollMarginTop = this.headerH - 30 + "px";
        });
    }
}

export class TinySlider {
    private offerSlider: HTMLElement | null;
    private offerWrapper: HTMLElement | null;

    constructor() {
        this.offerSlider = document.querySelector(".offers-slider");
        this.offerWrapper = document.querySelector(".offers-block-wrapper");
        // .offers-block-section .offers-block-list .offers-block-item

        if (this.offerSlider) {
            const offersCount = this.offerSlider.getElementsByTagName("li").length;
            let itemsToShow = 4;
            if (offersCount < itemsToShow) {
                itemsToShow = offersCount;
            }
            const slider = tns({
                container: this.offerSlider,
                items: 1,
                loop: false,
                gutter: 20,
                controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                responsive: {
                    1024: { items: 2 },
                    1200: { items: 3 },
                    1300: { items: itemsToShow }
                }
            });

            let firstMenuTop = document.querySelectorAll(".mega-menu");
            let slideBlock: any = document.querySelector(".slide-block");
            let slideBlockH = slideBlock?.offsetHeight;
            let mql = window.matchMedia("(max-width: 768px)")

        }
    }
}

class CustomerReviewSlider {
    private reviewSlider: HTMLElement | null;
    private reviewSlider1: HTMLElement | null;
    private reviewWrapper: HTMLElement | null;

    constructor() {
        this.reviewSlider = document.querySelector(".review-slider");
        this.reviewSlider1 = document.querySelector(".review-slider1");
        this.reviewWrapper = document.querySelector(".reviews-list-wrapper");

        let itemsCount = this.reviewSlider?.querySelectorAll(".reviews-item").length ?? 0;
        if (itemsCount < 4 && window.innerWidth >= 1024) {
            // Disable the slider by removing the class and emptying the container
            this.reviewSlider?.classList?.remove("review-slider");
        }
        else if (itemsCount == 1 && this.reviewWrapper) {
                this.reviewWrapper.style.paddingBottom = "0";
        } else {

            const setupReviewSlider = (sliderContainer: HTMLElement) => {
                const slider = tns({
                    container: sliderContainer,
                    items: 1,
                    loop: false,
                    controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                    responsive: {
                        1024: { items: 2 },
                        1200: { items: 3 }
                    }
                });

            };


            if (this.reviewSlider) {
                setupReviewSlider(this.reviewSlider);

                let firstMenuTop = document.querySelectorAll(".mega-menu");
                let slideBlock: any = document.querySelector(".slide-block");
                let slideBlockH = slideBlock?.offsetHeight;
                let mql = window.matchMedia("(max-width: 768px)")

            }

            if (this.reviewSlider1) {
                setupReviewSlider(this.reviewSlider1);
                let firstMenuTop = document.querySelectorAll(".mega-menu");
                let slideBlock: any = document.querySelector(".slide-block");
                let slideBlockH = slideBlock?.offsetHeight;
                let mql = window.matchMedia("(max-width: 768px)")

            }
        }
    }
}

// Since its a body component, needs to support multiple gallery sections on the same page
class PhotoGallerySlider {
    private readonly slideIndexMap = new Map<HTMLElement, number>();

    constructor() {
        const sections = document.querySelectorAll('.photo-gallery-section.content_manual');

        sections?.forEach(sectionEl => {
            const gallerySlider = sectionEl?.querySelector(".gallery-slider") as HTMLElement;
            const modal = sectionEl?.querySelector(".gallery-modal") as HTMLElement;
            if (!modal) return;
            const slides = modal?.getElementsByClassName("pop-up-slider") || [];

            const prevBtn = removeElementEventListeners(modal?.querySelector(".prev")) as HTMLButtonElement;
            const nextBtn = removeElementEventListeners(modal?.querySelector(".next")) as HTMLButtonElement;
            const closeModalBtn = removeElementEventListeners(modal?.querySelector(".close"));
            if (!prevBtn || !nextBtn || !closeModalBtn) return;
            const section = sectionEl as HTMLElement;
            this.slideIndexMap.set(section, 1);

            const openModal = () => {
                if (modal) modal.style.display = "flex";
            };

            closeModalBtn?.addEventListener("click", () => {
                if (modal) modal.style.display = "none";
            });

            const galleryList = section.querySelector('.gallery-wrapper .photo-gallery-list') as HTMLUListElement;
            galleryList?.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                const img = event.target as HTMLElement;
                if (img instanceof HTMLImageElement) {
                    const index = Array.from(galleryList.querySelectorAll('img')).indexOf(img);
                    this.setSlideIndex(section, index + 1);
                    openModal();
                    this.showSlides(section, slides, index + 1);
                    this.updateNavButtons(section, slides, prevBtn, nextBtn);
                }
            });

            prevBtn?.addEventListener("click", () => {
                this.plusSlides(section, -1, slides, prevBtn, nextBtn);
            });

            nextBtn?.addEventListener("click", () => {
                this.plusSlides(section, 1, slides, prevBtn, nextBtn);
            });

            // Initialize Tiny Slider
            if (gallerySlider) {
                tns({
                    container: gallerySlider,
                    items: 1,
                    loop: false,
                    slideBy: 'page',
                    nav: true,
                    navPosition: "bottom",
                    controlsText: [
                        '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>',
                        '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'
                    ],
                    responsive: {
                        1024: { items: 2 },
                        1200: { items: 3 }
                    }
                });
            }
        });
    }

    private setSlideIndex(section: HTMLElement, index: number) {
        this.slideIndexMap.set(section, index);
    }

    private getSlideIndex(section: HTMLElement): number {
        return this.slideIndexMap.get(section) ?? 1;
    }

    private plusSlides(
        section: HTMLElement,
        n: number,
        slides: HTMLCollectionOf<Element>,
        prevBtn: HTMLButtonElement,
        nextBtn: HTMLButtonElement
    ) {
        let index = this.getSlideIndex(section) + n;

        if (index < 1) index = 1;
        if (index > slides.length) index = slides.length;

        this.setSlideIndex(section, index);
        this.showSlides(section, slides, index);
        this.updateNavButtons(section, slides, prevBtn, nextBtn);
    }

    private showSlides(section: HTMLElement, slides: HTMLCollectionOf<Element>, n: number) {
        for (const element of slides) {
            (element as HTMLElement).style.display = "none";
        }
        const slideToShow = slides[n - 1] as HTMLElement;
        if (slideToShow) slideToShow.style.display = "flex";
    }

    private updateNavButtons(
        section: HTMLElement,
        slides: HTMLCollectionOf<Element>,
        prevBtn: HTMLButtonElement,
        nextBtn: HTMLButtonElement
    ) {
        const index = this.getSlideIndex(section);
        prevBtn.disabled = index === 1;
        nextBtn.disabled = index === slides.length;
    }
}
//END of Photo gallery changes //

class ChargerServiceSlider {
    private stepsSlider: HTMLElement | null;
    private stepsWrapper: HTMLElement | null;

    constructor() {
        this.stepsSlider = document.querySelector(".steps-slider");
        this.stepsWrapper = document.querySelector(".steps-img-wrapper");

        const setupSeviceSlider = (sliderContainer: HTMLElement) => {
            const slider = tns({
                container: sliderContainer,
                items: 1,
                loop: false,
                slideBy: 'page',
                nav: true,
                navPosition: "bottom",
                // controlsPosition: "bottom",
                controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                responsive: {
                    1024: {
                        items: 1,
                    }
                }
            });

            const stepsSliderlist = sliderContainer.getElementsByTagName("li").length;

            const progress = document.querySelectorAll(".card-step");
            const cardSelector = document.querySelector('.card-steps-wrapper') as HTMLElement;
            const prevStep = document.querySelector('.service-steps button[data-controls="prev"]');
            const nextStep = document.querySelector('.service-steps button[data-controls="next"]');
            let steps = 0;
            prevStep?.addEventListener('click', () => {
                if (steps > 0) {
                    steps--;
                    progress.forEach((progressStep, idx) => {
                        if (idx === steps) {
                            progressStep.classList.add("active-step");
                        } else {
                            progressStep.classList.remove("active-step");
                        }
                    });
                }
                if (window.innerWidth < 1024) {
                    cardSelector?.scrollBy(-322, 0);
                }
                else {
                    cardSelector?.scrollBy(-316, 0);
                }
            });
            nextStep?.addEventListener('click', () => {
                if (steps < stepsSliderlist - 1) {
                    steps++;
                    progress.forEach((progressStep, idx) => {
                        if (idx === steps) {
                            progressStep.classList.add("active-step");
                        } else {
                            progressStep.classList.remove("active-step");
                        }
                    });
                }
                if (window.innerWidth < 1024) {
                    cardSelector?.scrollBy(322, 0);
                }
                else {
                    cardSelector?.scrollBy(316, 0);
                }
            });
        };

        if (this.stepsSlider) {
            setupSeviceSlider(this.stepsSlider);
            let firstMenuTop = document.querySelectorAll(".mega-menu");
            let slideBlock: any = document.querySelector(".slide-block");
            let slideBlockH = slideBlock?.offsetHeight;
            let mql = window.matchMedia("(max-width: 768px)")

        }


    }


}

class WindowSlider {
    constructor() {
        this.initWindowSlider();
        if (window.screen && window.screen.width < 1024) {
            this.initWindowWrapSlider();
        }
    }

    // This function for Desktop
    private initWindowSlider() {
        const windowSliderElements = document.querySelectorAll(".window-slider");
        this.initSlider(windowSliderElements);
    }

    // This function for Mobile devices
    private initWindowWrapSlider() {
        const windowWrapElements = document.querySelectorAll(".window-wrap");
        this.initSlider(windowWrapElements);
    }

    private initSlider(nodeList: NodeListOf<Element>) {
        let countSliders = document.getElementsByClassName('window-list-wrapper');
        for (let i = 0; i < countSliders.length; i++) {
            if (nodeList[i]) {
                const slider = tns({
                    container: nodeList[i] as HTMLElement,
                    items: 1,
                    slideBy: "page",
                    loop: false,
                    navPosition: "bottom",
                    controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                    responsive: {
                        640: {
                            items: 2,
                        },
                        1024: {
                            items: 4
                        }
                    },
                });
            }
        }
    }
}

 class LogoImgSlider {
    constructor() {

        this.logoImgSliderFunction();
        
    }
     private logoImgSliderFunction() {
         const allSliders = document.querySelectorAll<HTMLElement>(".logo-img-slider");
        if (!allSliders || allSliders.length === 0) {
            return;
        }
         allSliders.forEach((slider) => {
             if (!slider) { return};
             const wrapper = slider.closest(".logo-img-carousel-wrap");
             if (!(wrapper instanceof HTMLElement)) return;
             const items = slider.querySelectorAll(".logo-img-carousel-item").length;
             if (items < 5 && window.innerWidth >= 1024) {
                 slider.classList.remove("logo-img-slider");
                 wrapper.style.paddingBottom = "0";
                 return;
             }
             if (slider.classList.contains("tns-initialized")) return;
             if (typeof tns === 'function') {
                 tns({ container: slider, items: 1,loop: false, slideBy: 'page', controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'], responsive: { 1024: { items: 2 }, 1200: { items: 5 } } });
                 slider.classList.add("tns-initialized");
             } else {
                 console.warn("Tiny Slider is not loaded.");
             }
         });
     }
 }
export const LogoImgSliderTest = {LogoImgSlider};
// INTERACTIVE IMAGE POPOVER JS STRATS HERE
export class PopoverBts {
    constructor() {
        this.handlePopoverButton();
    }
    private handlePopoverButton() {
        if (window.innerWidth > 768) {
            const openPopoverBtns = document.querySelectorAll('.open-modal-btn');
            const closePopoverBtns = document.querySelectorAll('.close-popover');
            openPopoverBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const popoverId: any = btn.getAttribute('data-popover-target');
                    const popover: any = document.getElementById(popoverId) as HTMLElement;
                    if (popover) {
                        popover.style.display = "flex";
                        popover.style.zIndex = "11";
                    }
                });
            });
            closePopoverBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const popover: any = btn.closest('[data-popover]');
                    if (popover) {
                        popover.style.display = "none";
                        popover.style.zIndex = "5";
                    }
                });
            });
        }
        if (window.innerWidth <= 768) {
            const openModalBtns = document.querySelectorAll('.open-modal-btn');
            const popoverMobile: HTMLElement | null = document.querySelector('.popover-mobile');
            if (popoverMobile != null) {
                popoverMobile.style.display = "none";
                openModalBtns.forEach(function (btn) {
                    btn.addEventListener('click', function () {
                        const popoverModal: any = btn.nextElementSibling;
                        const popoverContent = popoverModal.innerHTML;
                        // Copy popover content to popover-mobile
                        popoverMobile.innerHTML = popoverContent;

                        // Show popover-mobile
                        popoverMobile.style.display = "flex";

                        // Add event listener to the popoverMobile button
                        const popoverMobileBtn = popoverMobile.querySelector('.close-popover');
                        popoverMobileBtn?.addEventListener('click', function () {
                            // Hide popover-mobile when popoverMobileBtn is clicked
                            popoverMobile.style.display = "none";
                        });
                        // Add event listener to the document for clicks
                        document.addEventListener('click', function (event: any) {
                            const isClickedInsidePopoverMobile = popoverMobile.contains(event.target);
                            const isClickedInsideOpenModalBtn = Array.from(openModalBtns).some(function (openModalBtn) {
                                return openModalBtn.contains(event.target);
                            });
                            // Hide popover-mobile if click is outside
                            if (!isClickedInsidePopoverMobile && !isClickedInsideOpenModalBtn) {
                                popoverMobile.style.display = "none";
                            }
                        });
                    });
                });
            }
        }
    }
}
// INTERACTIVE IMAGE POPOVER JS ENDS HERE

//MultiImage Component
export class MultiImageModal {

    private multiImgSlideIndex = 1;
    private readonly multiImgSlides = document.getElementsByClassName("pop-up-img-slider");

    constructor() {
        const multiImageSection = document.querySelector(".multi-img-section");
        if (multiImageSection) {
            const multiImage = document.querySelectorAll('.multi-img-item');
            const closeBtn: any = document.querySelector('#multiImageModal .close');
            const prevBtn: any = document.querySelector('#multiImageModal .prev');
            const nextBtn: any = document.querySelector('#multiImageModal .next');


            closeBtn?.addEventListener('click', () => {
                (document.getElementById("multiImageModal") as HTMLElement).style.display = "none";
                document.body.style.overflow = '';
            })
            if (prevBtn) {
                prevBtn.addEventListener("click", () => this.plusMultiSlides(-1));
            }
            if (nextBtn) {
                nextBtn.addEventListener("click", () => this.plusMultiSlides(1));
            }


            multiImage?.forEach((item) => {
                item.addEventListener('click', () => {
                    const imageIdAttr = item.children[0]?.getAttribute('data-image-id');
                    const imageId = imageIdAttr !== null ? Number(imageIdAttr) : 0;
                    this.openModalMultiImg(imageId as any);
                });
            });
        }
    }

    public openModalMultiImg(imageId: string | null) {
        let modal = document.getElementById("multiImageModal");
        if (modal) {
            modal.style.display = "flex";
            document.body.style.overflow = 'hidden';
        }

        this.currentMultiSlide(imageId as any);
    }

    public plusMultiSlides(n: number) {

        const prevBtn: any = document.querySelector('#multiImageModal .prev');
        const nextBtn: any = document.querySelector('#multiImageModal .next');

        if (this.multiImgSlideIndex >= this.multiImgSlides.length - 1 && n > 0) {
            this.multiImgSlideIndex = this.multiImgSlideIndex + n;
            this.showMultiSlides(this.multiImgSlideIndex);
            this.disableButton(nextBtn, true);
            this.disableButton(prevBtn, false);
        }
        else if (this.multiImgSlideIndex <= 2 && n < 0) {
            this.multiImgSlideIndex = this.multiImgSlideIndex + n;
            this.showMultiSlides(this.multiImgSlideIndex);
            this.disableButton(nextBtn, false);
            this.disableButton(prevBtn, true);
        }
        else {
            this.multiImgSlideIndex = this.multiImgSlideIndex + n;
            this.showMultiSlides(this.multiImgSlideIndex);
            this.disableButton(nextBtn, false);
            this.disableButton(prevBtn, false);
        }
    }

    public disableButton(btn: HTMLButtonElement | null, isDisabled: boolean) {
        if (btn) {
            btn.disabled = isDisabled;
        }
    }

    public currentMultiSlide(n: number) {

        this.multiImgSlideIndex = n;
        this.showMultiSlides(this.multiImgSlideIndex);

        const prevBtn: any = document.querySelector('#multiImageModal .prev');
        const nextBtn: any = document.querySelector('#multiImageModal .next');
        const multiImgSlides = document.getElementsByClassName("pop-up-img-slider");

        if (this.multiImgSlideIndex === multiImgSlides.length) {
            this.disableButton(nextBtn, true);
        }
        else if (this.multiImgSlideIndex === 1) {
            this.disableButton(prevBtn, true);
            this.disableButton(nextBtn, false);
        }
        else {
            this.disableButton(nextBtn, false);
            this.disableButton(prevBtn, false);
        }

    };

    public showMultiSlides(n: number) {
        let i;
        const multiImgSlides = document.getElementsByClassName("pop-up-img-slider");
        if (n > multiImgSlides.length) {
            this.multiImgSlideIndex = 1;
        }
        if (n < 1) {
            this.multiImgSlideIndex = multiImgSlides.length;
        }
        for (i = 0; i < multiImgSlides.length; i++) {
            (multiImgSlides[i] as HTMLElement).style.display = "none";
        }
        (multiImgSlides[this.multiImgSlideIndex - 1] as HTMLElement).style.display = "flex";
    };
}
//Inspirational gallery is nonces and support multiple gallery sections on the same page
export class InspirationGallerySlider {
    private readonly sections: HTMLElement[];
    constructor() {
        this.sections = Array.from(document.querySelectorAll<HTMLElement>('.inspiration-gallery'));
        if (this.sections?.length) {
            this.sections?.forEach(section => this.init(section));
        }       
    }
    private init(section: HTMLElement) {
        const modal = section.querySelector<HTMLElement>("#galleryModal")!;
        const imageSlides = Array.from(section.getElementsByClassName("pop-up-slider")) as HTMLElement[];
        const galleryImages = section.querySelectorAll('.photo-card-item');

        if (!modal || imageSlides.length === 0) return;
        
        const closeBtn = modal.querySelector<HTMLButtonElement>('.close');
        const prevBtn = modal.querySelector<HTMLButtonElement>('.prev');
        const nextBtn = modal.querySelector<HTMLButtonElement>('.next');
    
        let currentSlideIndex = 1;
    
        const showSlides = (n: number) => {
          if (imageSlides.length === 0) return;
          if (n > imageSlides.length) currentSlideIndex = 1;
          if (n < 1) currentSlideIndex = imageSlides.length;
    
          imageSlides?.forEach(slide => (slide.style.display = "none"));
          imageSlides[currentSlideIndex - 1].style.display = "flex";
    
          prevBtn!.disabled = currentSlideIndex === 1;
          nextBtn!.disabled = currentSlideIndex === imageSlides.length;
        };
    
        const openModalImg = (slideIndex: number) => {
          if (!modal) return;
          modal.style.display = "flex";
          document.body.style.overflow = 'hidden';
          currentSlideIndex = slideIndex;
          showSlides(currentSlideIndex);
        };
    
        const plusSlides = (n: number) => {
          currentSlideIndex += n;
          showSlides(currentSlideIndex);
        };
    
        closeBtn?.addEventListener("click", () => {
          if (modal) modal.style.display = "none";
          document.body.style.overflow = "";
        });
    
        prevBtn?.addEventListener("click", () => plusSlides(-1));
        nextBtn?.addEventListener("click", () => plusSlides(1));
    
        galleryImages?.forEach((item) => {
          if (!item.querySelector(".video-area")) {
            const imageIdAttr = item.children[0]?.getAttribute("data-photo-id");
            const imageId = imageIdAttr ? Number(imageIdAttr) : 1;
            item?.addEventListener("click", () => openModalImg(imageId));
          }
        });
    
        this.copySocialLink(section);
      }

    public copySocialLink(section: HTMLElement) {

        const copyBlogLink: NodeListOf<Element> = section.querySelectorAll(".copy_link_share");

        // Loop through each element to add event listeners
        copyBlogLink?.forEach((element: Element) => {
            if (!element) return;
            element.addEventListener("click", (event: Event) => {
                event.preventDefault();
                let urlImg: string = decodeURIComponent(window.location.href);
                navigator.clipboard.writeText(urlImg)
                    .then(() => {
                        console.log('URL copied to clipboard');
                        alert(`${urlImg}\n Copied to Clipboard`);
                    })
                    .catch((err: any) => {
                        console.error('Failed to copy URL: ', err);
                    });
            });
        });

    }

}

export class TransformationSlider {
    constructor() {
        this.transFormationSlider();
    }

    private transFormationSlider() {
        let transfSlider = document.querySelector(".transformation-slider") as HTMLElement;
        if (transfSlider) {
            tns({
                container: transfSlider,
                items: 1,
                loop: false,
                gutter: 10,
                controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
            });
        }
    }
}

export class SolutionMagazineSlider {
    constructor() {
        this.solutionMagazineSlider();
        const solMagazineSlider = document.querySelector(".solution-magazine-slider");
        // Add event listener for slider change
        solMagazineSlider?.addEventListener('transitionend', this.handleSolutionSliderChange);
        // Initial setup with a slight delay to ensure everything is loaded
        setTimeout(this.handleSolutionSliderChange, 100);
    }

    private solutionMagazineSlider() {

        //SOLUTION MAGAZINE SECTION SLIDER JS STARTS HERE
        let solMagazineSlider = document.querySelector(".solution-magazine-slider");
        if (solMagazineSlider) {
            tns({
                container: solMagazineSlider,
                items: 1,
                loop: false,
                gutter: 10,
                controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                navContainer: "#magazine-thumbnails",
                navAsThumbnails: true,
                swipeAngle: false,
                onInit: this.handleSolutionSliderChange
            });
        }
    }

    private handleSolutionSliderChange() {

        const sliderElement = document.querySelector('.solution-magazine-slider') as HTMLLIElement;
        if (sliderElement) {

            const activeIndex = Array.from(sliderElement.children).findIndex(child => child.classList.contains('tns-slide-active'));

            const thumbnails = document.querySelectorAll('.thumbnails li') as any;
            const totalThumbnails = thumbnails.length;

            thumbnails.forEach(function (thumbnail: any) {
                thumbnail.style.display = 'none';
            });

            // Calculate the range of thumbnails to show
            const startIndex = Math.max(0, activeIndex - 2);
            const endIndex = Math.min(totalThumbnails, startIndex + 6);
            const numVisibleThumbnails = endIndex - startIndex;

            // Show the thumbnails within the range
            for (let i = startIndex; i < endIndex; i++) {
                thumbnails[i].style.display = 'inline-block';
            }

            // Adjust thumbnails if less than 6 are visible
            const additionalThumbnails = 6 - numVisibleThumbnails;
            if (additionalThumbnails > 0) {
                const startIndexToAdjust = Math.max(0, startIndex - additionalThumbnails);
                for (let j = startIndexToAdjust; j < startIndex; j++) {
                    thumbnails[j].style.display = 'inline-block';
                }
            }
        }
    }

}
// COLOR VISUALIZER SECTION SLIDER CHANGES STARTS HERE
class ColorVisualiserSlider {
    tinySliderInstance: any;
    allThumbnails: NodeListOf<Element> | undefined;
    dropdownBtn: HTMLElement | undefined;
    dropdownContent: any;
    btnContent: any;
    constructor() {
        let colorVisualSlider = document.querySelector(".color-visualizer-carousel");
        if (colorVisualSlider) {
            this.tinySliderInstance = tns({
                container: '.color-visualizer-carousel',
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls: true,
                loop: false,
                gutter: 10,
                controlsText: [
                    '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>',
                    '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'
                ],
                navAsThumbnails: true,
                nav: false,
            });

            this.allThumbnails = document.querySelectorAll('.thumbnails ul li');
            this.dropdownBtn = document.querySelector('.dropdown-btn') as HTMLElement;
            this.dropdownContent = document.querySelector('.dropdown-content');
            this.btnContent = this.dropdownBtn?.querySelector('.dropdown-btn-content');

            this.init();
        }
    }

    insertCheckIcon(container: Element) {
        const thumbIcon = container.querySelector('.thumb-icon');
        if (thumbIcon) {
            thumbIcon.innerHTML = `
          <svg class="icon">
            <use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#check-mark"></use>
          </svg>
        `;
        }
    }

    insertChevronIcon(container: any) {
        const thumbIcon = container.querySelector('.thumb-icon');
        if (thumbIcon) {
            thumbIcon.innerHTML = `
          <svg class="icon">
            <use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-down"></use>
          </svg>
        `;
        }
    }

    activateImageById(id: string | null) {
        document.querySelectorAll('.color-visualizer-item')?.forEach(item => {
            item?.classList.remove('active');
            if (item?.getAttribute('data-id') === id) item?.classList.add('active');
        });

        this.allThumbnails?.forEach(thumb => {
            thumb?.classList.remove('active-thumb');
            if (thumb?.getAttribute('data-id') === id) thumb?.classList.add('active-thumb');
        });

        this.dropdownContent?.querySelectorAll('li').forEach((li: any) => {
            li?.classList.remove('active-thumb');
            if (li?.getAttribute('data-id') === id) li?.classList.add('active-thumb');
        });

        this.dropdownContent?.querySelectorAll('li .thumb-icon').forEach((icon: any) => (icon.innerHTML = ''));
        document.querySelectorAll('.thumbnails ul li .thumb-icon').forEach(icon => (icon.innerHTML = ''));

        const activeDropdownThumb = this.dropdownContent?.querySelector(`li[data-id="${id}"] .palette-card`);
        const activeDesktopThumb = document.querySelector(`.thumbnails ul li[data-id="${id}"] .palette-card`);
        if (activeDropdownThumb) this.insertCheckIcon(activeDropdownThumb);
        if (activeDesktopThumb) this.insertCheckIcon(activeDesktopThumb);

        const activeLi = this.dropdownContent?.querySelector(`li[data-id="${id}"] .palette-card`);
        if (activeLi) {
            if (this.btnContent) this.btnContent.innerHTML = '';
            const clonedCard = activeLi.cloneNode(true);
            this.insertChevronIcon(clonedCard);
            if (this.btnContent) this.btnContent.appendChild(clonedCard);
        }
    }

    updateVisibleThumbnailsBySlide(currentSlide: Element) {
        const imageItems = currentSlide?.querySelectorAll('.color-visualizer-item');
        const idsToShow: string[] = [];

        imageItems?.forEach(img => {
            const id = img.getAttribute('data-id');
            if (id) idsToShow.push(id);
        });

        this.allThumbnails?.forEach(thumb => {
            const id = thumb?.getAttribute('data-id');
            if (!id) return;
            (thumb as HTMLElement).style.display = idsToShow?.includes(id) ? 'inline-block' : 'none';
        });

        if (this.dropdownContent) this.dropdownContent.innerHTML = '';
        this.allThumbnails?.forEach(thumb => {
            const id = thumb?.getAttribute('data-id') ?? '';
            if (idsToShow?.includes(id)) {
                const clone = thumb?.cloneNode(true) as HTMLLIElement;
                clone?.setAttribute('data-id', id);
                this.dropdownContent?.appendChild(clone);

                clone.addEventListener('click', () => {
                    this.activateImageById(id);
                    if (this.dropdownContent) this.dropdownContent.style.display = 'none';
                    const paletteCard = clone.querySelector('.palette-card');
                    if (paletteCard) {
                        const clonedCard = paletteCard.cloneNode(true);
                        this.insertChevronIcon(clonedCard); // Add chevron icon
                        if (this.btnContent) {
                            this.btnContent.innerHTML = '';
                            this.btnContent.appendChild(clonedCard);
                        }
                    }
                });
            }
        });
    }

    init() {
        const thumbnailsContainer = document.querySelector('.color-visualizer-section .thumbnails');
        const dropdownContainer = document.querySelector('.color-visualizer-section .thumbnails-dropdown');
        if (this.allThumbnails?.length) {
            let allMissingImages = true;
            let allMissingTitles = true;

            this.allThumbnails?.forEach(thumb => {
                const img = thumb?.querySelector('.color-vir-li-img img') as HTMLImageElement;
                const rawSrc = img?.getAttribute('src');
                const textSpan = thumb?.querySelector('.color-var-li-text');
                if (!rawSrc && img) {
                    // Hide image if src is missing to avoid broken image
                    img.style.display = 'none';
                } else if (rawSrc && rawSrc.trim() !== '') {
                    // At least one image has a src
                    allMissingImages = false;
                }
                // At least one pallette has title
                if (textSpan?.textContent?.trim()) {
                    allMissingTitles = false;
                }
                thumb?.addEventListener('click', () => {
                    const id = thumb?.getAttribute('data-id');
                    this.activateImageById(id);
                });
            });
            //Class gets added only when all the images in color pallette doesn't have src
            if (allMissingImages) {
                thumbnailsContainer?.classList.add('thumbnails-only-title');
                dropdownContainer?.classList.add('thumbnails-only-title');
            }
            //Class gets added only when all the images in color pallette doesn't have title
            if (allMissingTitles) {
                thumbnailsContainer?.classList.add('thumbnails-only-image');
                dropdownContainer?.classList.add('thumbnails-only-image');
            }
        }

        this.dropdownBtn?.addEventListener('click', (e: any) => {
            e.stopPropagation();
            if (!this.dropdownContent) return;
            const isOpen = this.dropdownContent?.style.display === 'block';
            this.dropdownContent.style.display = isOpen ? 'none' : 'block';
            if (!isOpen) {
                const activeThumb = this.dropdownContent?.querySelector('.active-thumb .palette-card');
                if (activeThumb) {
                    if (this.btnContent)
                        this.btnContent.innerHTML = '';
                    const clonedCard = activeThumb.cloneNode(true);
                    this.insertChevronIcon(clonedCard);
                    if (this.btnContent)
                        this.btnContent.appendChild(clonedCard);
                }
            }
        });

        document.addEventListener('click', e => {
            const target = e.target as HTMLElement | null;
            if (target && !target.closest('.thumbnails-dropdown') && !target.closest('.dropdown-btn')) {
               if(this.dropdownContent) this.dropdownContent.style.display = 'none';
            }
        });

        this.tinySliderInstance?.events?.on('indexChanged', (info: any) => {
            const currentSlide = info.slideItems[info.index];
            currentSlide?.querySelectorAll('.color-visualizer-item').forEach((img: any, idx: any) => {
                img?.classList.remove('active');
                if (idx === 0) img?.classList.add('active');
            });
            this.updateVisibleThumbnailsBySlide(currentSlide);

            const activeImg = currentSlide?.querySelector('.color-visualizer-item.active');
            if (activeImg) {
                this.activateImageById(activeImg.getAttribute('data-id'));
            }
        });

        window.addEventListener('load', () => {
            const checkSliderReady = setInterval(() => {
                const sliderInfo = this.tinySliderInstance?.getInfo();
                if (sliderInfo && sliderInfo?.slideItems?.length > 0) {
                    clearInterval(checkSliderReady);
                    const currentSlide = sliderInfo.slideItems[sliderInfo.index];
                    this.updateVisibleThumbnailsBySlide(currentSlide);

                    const activeImg = currentSlide.querySelector('.color-visualizer-item.active');
                    if (activeImg) {
                        this.activateImageById(activeImg.getAttribute('data-id'));
                    }
                }
            }, 100);
        });
        // Modal image view
        const modal = document.getElementById('color-image-modal');
        const modalImg = document.getElementById('color-modal-img');
        const closeModalBtn = document.querySelector('.visual-close');

        document.querySelectorAll('.color-visualizer-item img')?.forEach(img => {
            img?.addEventListener('click', function (this: HTMLImageElement) {
                if (modal) {
                    modal.style.display = 'flex';
                }
                if (modalImg) {
                    const imgElement = modalImg as HTMLImageElement; // Cast modalImg to HTMLImageElement
                    imgElement.src = this.getAttribute('data-large') ?? '';  // `this` refers to the clicked <img>
                    imgElement.alt = this.alt || '';  // `this` refers to the clicked <img>
                }
            });
        });


        closeModalBtn?.addEventListener('click', function () {
            if (modal) modal.style.display = 'none';
        });

        modal?.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        });
    }
}

//COLOR VISUALIZER SECTION SLIDER CHANGES END HERE


// COMPONENT - 68 - EVENT TEASER COMPONENT SLIDER TS STARTS HERE
export class EventTeaserSlider {
    private static instance: EventTeaserSlider | null = null;

    constructor() {
        this.initSlider();
    }

      // Public method to get the single instance of the class
      public static getInstance(): EventTeaserSlider {
        EventTeaserSlider.instance ??= new EventTeaserSlider();
        return EventTeaserSlider.instance;
    }

    private initSlider(): void {
        const eventTeaserSlider = document.querySelector(".upcoming-events-slider .card-list") as HTMLElement;

        if (eventTeaserSlider) {
            
            tns({
                container: eventTeaserSlider,
                items: 1,
                loop: false,
                slideBy: 'page',
                nav: true,
                navPosition: "bottom",
                // controlsPosition: "bottom",
                controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                responsive: {
                    1024: {
                        items: 2,
                    },
                    1200: {
                        items: 3,
                    }
                }
            });
        }
    }
}


// COMPONENT - 68 - EVENT TEASER COMPONENT SLIDER TS ENDS HERE

document.addEventListener("DOMContentLoaded", () => {
    const stickyHeader = new StickyHeader();
    const asideDiv = new AsideDiv();
    const offersliderElement = new TinySlider();
    const customerReviewSlider = new CustomerReviewSlider();
    const photoGallerySlider = new PhotoGallerySlider();
    const chargerServiceSlider = new ChargerServiceSlider();
    const windowSlider = new WindowSlider();
    new LogoImgSlider();
    new PopoverBts();
    new MultiImageModal();
    new InspirationGallerySlider();
    new TransformationSlider();
    new SolutionMagazineSlider();
    new ColorVisualiserSlider();
    EventTeaserSlider?.getInstance();


    // If the user is localize and DBA checkbox is checked then adding class menu-local in header wrapper
    setTimeout(() => {
        const screenType = reportScreenSize();
        if (screenType !== ScreenType.Desktop) {
            replaceLeadCtaWithClick();
            stickyFooter();
        }
    }, 1000);

    // If the user is localise then replacing the national banner information with local banner information
    addLocalizationHeaderBannerInformationLocal();
    if(isTouchDevice()){
        clickToCallHandler();
    }
    attachEventListnerForCoupon8();
    const OfferSection = document.querySelector('.offers-block-section');
    //To avoid event to get attached twice to asv dynamic offer teaser as it contains offers-block-section class
    if (!OfferSection?.classList.contains('dynamic-offer-teaser-component')) {
        attachEventListnerForCoupon11();
    }
    addNblyHeaderInformation();
    truncateTextWithEllipsis();
    localDynamicMenuLargeMediaTile();
    localDynamicMenuLarge2575MediaTile();
    //Read More function call//
    readMoreButton();
    dynamicMenuServiceAccordion();
    dynamicScroll();
});
//Read More//
function readMoreButton() {
    const readMoreWrap = document.querySelector('.read-more-wrap') as HTMLElement;
    if (readMoreWrap) {
        const originalContent = readMoreWrap.innerHTML.trim();
        const words = originalContent.split(/\s+/);

        // Check if the content exceeds 400 words
        if (words.length > 100) {
            // Truncate the text to 400 words
            const truncatedContent = words.slice(0, 100).join(' ') + '...';
            readMoreWrap.innerHTML = truncatedContent;

            // Create and add the "Read More" button
            const readMoreButton = document.createElement('button');
            readMoreButton.textContent = '...Read More';
            readMoreButton.className = "red-more-button";
            readMoreButton.style.width = "fit-content";
            readMoreWrap.appendChild(readMoreButton);

            if (readMoreButton) {
                readMoreButton.addEventListener('click', function () {
                    if (readMoreButton.textContent === "...Read More") {
                        // Show the full content
                        readMoreWrap.innerHTML = originalContent;
                        readMoreButton.textContent = "...Read Less";
                        readMoreWrap.appendChild(readMoreButton); // Re-attach the button
                    } else {
                        // Re-truncate the content
                        readMoreWrap.innerHTML = truncatedContent;
                        readMoreButton.textContent = "...Read More";
                        readMoreWrap.appendChild(readMoreButton); // Re-attach the button
                    }
                });
            }
        }
    }
 }
 //End//
export async function addLocalizationHeaderMenuLocal() {
    try {
        const headerWrapper = document.querySelector(".header-wrapper") as HTMLElement;
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        const dbaName = localStorage.getItem('dbaName');
        if (headerWrapper && brandData?.show_localheader_dba_center && dbaName) {
            headerWrapper.classList.add("menu-local");
        } else {
            headerWrapper?.classList.remove("menu-local");
        }
    } catch (error) {
        console.error("An error occurred in the addLocalizationHeaderMenuLocal function:", error);
    }

}

async function replaceLeadCtaWithClick() {
    let brandDetails = localStorage.getItem("brandDetails") as any;
    const fullAttrOnLoad = localStorage.getItem("fullAttrOnLoad");
    const dbaName = localStorage.getItem("dbaName");
    const phoneNumber = await getDisplayPhoneNumber();
      const siteConfigDisplayClickToCallCta = localStorage.getItem("siteConfigDisplayClickToCallCta");

    if (brandDetails) {
        brandDetails = JSON.parse(brandDetails);
    }
    const allLeadCtaHeader = document.querySelectorAll(".replace-with-click-to-lead-cta.cta-header-component-lead");
    const allClickToCtaHeader = document.querySelectorAll(".replace-with-click-to-call-cta.cta-header-component-call");
    const allLeadCtaBody = document.querySelectorAll(".replace-with-click-to-lead-cta.cta-body-component-lead");
   
    const isActive = fullAttrOnLoad && isOperationActiveNow(JSON.parse(fullAttrOnLoad)?.hoursofOperation);
    const updateCtaHeader = (element: any) => {
        if (brandDetails?.mobile_cta_text) {
            element.innerHTML = brandDetails.mobile_cta_text;
        }
        if (element) {
            const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svgElement.innerHTML = brandDetails.mobile_cta_icon;
            element.prepend(svgElement);
        }
        if (element instanceof HTMLAnchorElement && phoneNumber) {
            element.href = `tel:${phoneNumber.replace(/[\(\)\-\s]/g, "")}`;
        }
    };
    const hideElements = (elements: any) => {
        elements.forEach((element: any) => {
            element.classList.add("hidden");
        });
    };
    
    const showElements = (elements: any) => {
        elements.forEach((element: any) => {
            element.classList.remove("hidden");
        });
    };
    
    if (brandDetails?.displayClickToCallCtaHeader && siteConfigDisplayClickToCallCta === 'true' && brandDetails?.displayClickToCallCtaBody && ((!dbaName) || (dbaName && fullAttrOnLoad && isActive))) {
        //replace in header and body
        hideElements(allLeadCtaHeader);
        hideElements(allLeadCtaBody);
        showElements(allClickToCtaHeader);
        allClickToCtaHeader.forEach(updateCtaHeader);
        showElements(allLeadCtaBody);
        allLeadCtaBody.forEach(updateCtaHeader);
     
    }
    else if (brandDetails?.displayClickToCallCtaHeader && siteConfigDisplayClickToCallCta === 'true' && !brandDetails?.displayClickToCallCtaBody && ((!dbaName) || (dbaName && fullAttrOnLoad && isActive))) {
        //replace only in header
        hideElements(allLeadCtaHeader);
        showElements(allLeadCtaBody);
        showElements(allClickToCtaHeader);
        allClickToCtaHeader.forEach(updateCtaHeader);
       
    }  
    else if (!brandDetails?.displayClickToCallCtaHeader && siteConfigDisplayClickToCallCta === 'true' && brandDetails?.displayClickToCallCtaBody && ((!dbaName) || (dbaName && fullAttrOnLoad && isActive))) {
       //replace only in body
        showElements(allLeadCtaHeader);
        showElements(allClickToCtaHeader);
        showElements(allLeadCtaBody);
        allLeadCtaBody.forEach(updateCtaHeader);
       
    }
    else {
        showElements(allLeadCtaHeader);
        showElements(allLeadCtaBody);
        showElements(allClickToCtaHeader);
    }
}

// Function to get the page type

function addLocalizationHeaderBannerInformationLocal() {
    const headerElement = document.getElementById("header-alert") as HTMLDivElement;
    if (headerElement) {
        getMessagesData().then((data) => {
            const informationBanner = data?.informationBanner;
            if (informationBanner) {
                headerElement.classList.remove("alert-warning");
                headerElement.classList.remove("alert-info");
                headerElement.classList.remove("alert-danger");

                if (informationBanner?.alertClass && typeof informationBanner.alertClass === 'string') {
                    headerElement.classList.add(informationBanner.alertClass);
                }

                if (informationBanner?.infotext) {
                    const wysiwygElement = headerElement?.querySelector('.alert-text .wysiwyg') as HTMLElement;
                    if (wysiwygElement) {
                        wysiwygElement.innerHTML = informationBanner?.infotext;
                    }
                }

                if (informationBanner?.infosvg) {
                    const svgElement = headerElement?.querySelector('.inner-alert svg') as HTMLElement;
                    if (svgElement) {
                        svgElement.innerHTML = informationBanner?.infosvg;
                    }
                }

            }
        }).catch((err) => {
            console.log(err, "Error in getting the function addLocalizationHeaderBannerInformationLocal");
        });
    }
}
// Sticky Footer 
async function stickyFooter() {
    const footerMainEle = document.querySelector('.sticky-footer') as HTMLElement;
    if (footerMainEle) {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        const dbaName = localStorage.getItem('dbaName');
        if (brandData?.enable_sticky_footer_national && !dbaName) {
            enableStickyFooter(brandData);
        }
        if (brandData?.enable_sticky_footer_local && dbaName) {
            enableStickyFooter(brandData);
        }

    }
}

function enableStickyFooter(brandData: any) {
    const footerMainEle = document.querySelector('.sticky-footer') as HTMLElement;
    const footerFooterTitle = footerMainEle.querySelector('.sticky_title') as HTMLElement;
    const footerFooterIcon = footerMainEle.querySelector('.icon.sticky_icon') as HTMLElement;
    footerMainEle?.classList?.remove('hidden');
    if (brandData.sticky_subtitle && footerFooterTitle) {
        footerFooterTitle.innerHTML = brandData.sticky_subtitle;

        if (brandData?.sticky_subtitle_icon?.trim() && footerFooterIcon) {
            footerFooterIcon.innerHTML = brandData.sticky_subtitle_icon;
        }
    }
    if (brandData?.sticky_icon?.trim() && footerFooterIcon) {
        footerFooterIcon.innerHTML = brandData.sticky_icon;
    }
    if(!footerFooterTitle && brandData.sticky_title){
        const anchorTag = document.querySelector(".sticky-footer .sticky-footer-cta")as HTMLElement;
        if(anchorTag){
            const anchorTagText = anchorTag.outerHTML;
            const replacedText = `${anchorTagText.split("</svg>")[0]}</svg>${brandData.sticky_title}</a>`;
            const footerWrap = document.querySelector(".sticky-footer-wrap") as HTMLElement;
            if(footerWrap)
                footerWrap.innerHTML = replacedText;
            else
            //fallback scenario
            if(anchorTag.parentElement){
                anchorTag.parentElement.innerHTML = replacedText;
            }
        }
    }
    
}

// Add class on gallery popup modal when card footer not availabel
document.querySelectorAll('.gallery-modal .modal-content .pop-up-img-slider').forEach(li => {
    if (!li.querySelector('.card-footer')) {
        li?.classList.add('no-footer'); // Adds class to li if it doesn't contain a div
    }
});


document.addEventListener('DOMContentLoaded', async function () {

    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);

    const hideDBANameAndPhoneMobile = (hideAttr: string) => {
        const phoneElement = document.querySelectorAll(`.${hideAttr}`);
        phoneElement?.forEach((element) => {
            if (element && brandData?.[hideAttr]) {
                element.classList.add('hidden');
                (element as HTMLElement).style.display = 'none';
            } else {
                if (hideAttr !== 'disable_phone_cta_os_flow') {
                    (element as HTMLElement).style.display = 'block';
                }
                element?.classList.remove('hidden');
            }
        });
    }


    hideDBANameAndPhoneMobile(`disable_phone_os_flow`);
    hideDBANameAndPhoneMobile(`disable_dba_os_flow`);
    const screenType = reportScreenSize();
    if (screenType !== ScreenType.Desktop) {
        hideDBANameAndPhoneMobile(`disable_phone_cta_os_flow`); // for mobile devices
    }
})
//US-460495: Add new CTA for 50-50 media tiles component Start
  function clickToCallHandler(){
    // Select all elements with the class 'card-main clicktocall'
    const clickToCallDivs = document.querySelectorAll<HTMLDivElement>('.card-item .card-main.clicktocall');
    if (clickToCallDivs.length > 0) {
        clickToCallDivs.forEach((div) => {
            //For each clicktocall card add the dni number in href
            const mobileLink = div.querySelector<HTMLAnchorElement>('.mobile-only');
            const fullLink = div.querySelector<HTMLAnchorElement>('.full-link');
            if (mobileLink && fullLink) {
                const dniNumber = mobileLink.getAttribute('href');
                if(dniNumber){
                    fullLink.setAttribute('href', dniNumber);
                    fullLink.removeAttribute('target')
                }
            }
        });
    }
  }
  //US-460495: Add new CTA for 50-50 media tiles component End
  
   //-----------------Coupon 8----------------------------//
   function attachEventListnerForCoupon8() {
    attachEventListenerForClaim('.sp-offers-section.coupons-eight', '.sp-offers-cta a.secondary-btn','li.sp-offers-item',{
        titleSelector: '.sp-offers-details .sp-offer',
        descriptionSelector: '.sp-offers-details .sp-offer-desc',
        expirySelector: '.sp-offer-expire',
        disclaimerSelector: '.sp-offers-disclaimer',
        couponCodeInputSelector: '#coupons-code'
    }); 
}

 //-----------------Coupon 11----------------------------//

function attachEventListnerForCoupon11() {
    attachEventListenerForClaim('.offers-block-section', '.offers-block-item a.secondary-btn','li.offers-block-item',{
        titleSelector: '.offers-block-details .block-offer',
        descriptionSelector: '.offers-block-details .offers-block-desc',
        expirySelector: '.offers-block-main .offers-block-expire',
        disclaimerSelector: '.offers-block-disclaimer',
        couponCodeInputSelector: '#block-coupons-code'
    }); 
    
}

/********* Added NBLY header logo and CTA text for National & Localisation page *********/

function addNblyHeaderInformation() {
    const nblyMain = document.querySelector('.nbly-main') as HTMLElement;
    const nblyCta = nblyMain?.querySelector('.nbly-cta') as HTMLElement;
    if (!nblyMain) return;
    getMessagesData().then((data) => {
        const nblyHeaderBanner = data?.nblyHeaderBanner;
        if (nblyHeaderBanner) {
            handleNblyHeaderImage(nblyMain, nblyHeaderBanner);
            handleNblyHeaderCta(nblyCta, nblyHeaderBanner);
        }
    }).catch((err) => {
        console.log(err, "Error in getting the function addNblyHeaderInformation");
    });
}

function handleNblyHeaderImage(nblyMain: HTMLElement, nblyHeaderBanner: any) {
    const nblyImgLogo = nblyMain?.querySelector('.nbly-logo') as HTMLElement;
    const nblyImgLogoAnchorTag = nblyMain?.querySelector('.nbly-block a') as HTMLElement;

    const nblyLogo = nblyHeaderBanner?.logoImage;
    const nblyAltText = nblyHeaderBanner?.logoAltText;
    const nblyOpenNewTab = nblyHeaderBanner?.logoOpenNewTab?.toLocaleLowerCase();
    const nblyImageLink = nblyHeaderBanner?.imageLink;

    if (nblyOpenNewTab === 'yes' && nblyImgLogoAnchorTag) {
        nblyImgLogoAnchorTag.setAttribute('target', '_blank');
    }
    if (nblyImageLink && nblyImgLogoAnchorTag) {
        nblyImgLogoAnchorTag.setAttribute('href', nblyImageLink);
    }

    if (nblyImgLogo && nblyLogo) {
        nblyImgLogo.innerHTML = nblyLogo;
    }

    if (nblyAltText && nblyImgLogo) {
        nblyImgLogo.setAttribute('alt', nblyAltText);
    }
}

function handleNblyHeaderCta(nblyCta: HTMLElement | null, nblyHeaderBanner: any) {
    const nblyCtaText = nblyHeaderBanner?.nblyHeader_link;
    if (nblyCta && nblyCtaText?.length > 0) {
        nblyCta.innerHTML = '';
        nblyCtaText?.forEach((ctaText: any) => {
            const nblyCtaAnchorTag = document.createElement('a');
            const ctaAnchorText = ctaText.linkText;
            const ctaClass = ctaText.ctaClass;
            const ctaLinkType = ctaText.linkType;
            const ctaOpenNewTab = ctaText.openNewTab?.toLocaleLowerCase();

            if (ctaLinkType) {
                nblyCtaAnchorTag.setAttribute('href', ctaLinkType);
            }
            if (ctaClass) {
                nblyCtaAnchorTag.setAttribute('class', ctaClass);
            }
            if (ctaOpenNewTab === 'yes') {
                nblyCtaAnchorTag.setAttribute('target', '_blank');
            }
            if (ctaAnchorText) {
                nblyCtaAnchorTag.innerHTML = ctaAnchorText;
            }

            nblyCta.appendChild(nblyCtaAnchorTag);
        });
    }
}

/** End NBLY Header */


/*************** Start Service Large Media Tile Component ********************/
    function truncateTextWithEllipsis() {
        const paragraphs = document.querySelectorAll(".service-tile-card-subtext");
        const container = document.querySelector('.service-tile-list');
    
        if (paragraphs?.length > 0) {
            paragraphs.forEach(paragraph => {
                if (paragraph?.textContent) {  // Ensure paragraph and textContent are not null
                    const fullText = paragraph.textContent.trim();
                    const shortText = fullText.slice(0, 140);
    
                    // Only create ellipsis if fullText is longer than 140 characters
                    if (fullText.length > 140) {
                        const ellipsis = document.createElement("span");
                        ellipsis.textContent = "...";
                        ellipsis.classList.add("ellipsis");
                        ellipsis.style.cursor = "pointer";
                        ellipsis.setAttribute('data-fulltext', fullText);

                        // Ensure we modify paragraph text content safely
                        paragraph.textContent = shortText;
                        paragraph.appendChild(ellipsis);
                    }
                }
            });

            container?.addEventListener("click", (event) => {
                // Check if the clicked element is an ellipsis
                const target = event.target as HTMLElement;
                if (target?.classList.contains("ellipsis")) {
                    const paragraph = (event?.target as HTMLElement)?.parentElement; 
                    if (paragraph?.textContent) {
                        const fullText = (event.target as HTMLElement)?.getAttribute('data-fulltext');
                        if(fullText){
                            paragraph.textContent = fullText;
                        }
                    }
                }
            });
        }
    }
    
/*************** End Service Large Media Tile Component ********************/

/*************** NEW DYNAMIC MENU STARTS HERE *****************************/

export function dynamicMenuV4(dynamicMenuType: any) {
    
    const jsonDynamicMenu = dynamicMenuType ?? {};

    if(jsonDynamicMenu?.dynamicMenuType?.toLowerCase()?.trim() ==='dynamic menu icons'){
        document.querySelectorAll('.new-expand-menu.no-tab-switch').forEach((menuItem) => {
            menuItem.addEventListener('click', function (this: HTMLElement, event: Event) {
                event.preventDefault();

                const closestTabSibling = (menuItem as HTMLElement).closest(".tab-sibling");
                if (closestTabSibling) {
                    closestTabSibling.classList.add('hide-menu');
                }

                const targetMenuId = this.getAttribute('data-target');
                const targetMenu = targetMenuId ? document.getElementById(targetMenuId) : null;
                // const dynamicMenuWrap = document.querySelector('.dynamic-menu-wrap');
                const dynamicMenuWrap = targetMenu?.parentElement?.parentElement;

                if (dynamicMenuWrap?.classList.contains('dynamic-menu-wrap')) {
                    dynamicMenuWrap.classList.remove('hide-menu');
                    dynamicMenuWrap.classList.add('show-menu');
                }

                if (targetMenu) {
                    document.querySelectorAll('.new-submenu-inner-warp > div').forEach((subMenu) => {
                        subMenu.classList.add('hide-menu');
                        subMenu.classList.remove('show-menu');
                    });

                    document.querySelectorAll('.new-submenu-inner-wrap-mobile > div').forEach((subMenu) => {
                        subMenu.classList.add('hide-menu');
                        subMenu.classList.remove('show-menu');
                    });

                    targetMenu.classList.remove('hide-menu');
                    targetMenu.classList.add('show-menu');
                }
            });

            // Main back button functionality
            const backToMenuBtn = document.querySelectorAll('.back-to-menu-btn');
            backToMenuBtn.forEach((back) => {
                back.addEventListener('click', function handleClick(this: HTMLElement) {
                    const nameBack = this.getAttribute('data-back');
                    if (nameBack) {
                        const idWrap = document.getElementById(nameBack);
                        if (idWrap) {
                            idWrap.classList.remove('show-menu');
                            idWrap.classList.add('hide-Submenu');

                            const dynamicMenuWrap = idWrap?.closest('.dynamic-menu-wrap');
                            if (dynamicMenuWrap) {
                                dynamicMenuWrap.classList.add('hide-menu');
                                dynamicMenuWrap.classList.remove('show-menu');
                            }
                        }
                    }
                });
            });

            // Back button functionality
            const newBackBtn = document.querySelectorAll('.new-back-btn');
            newBackBtn.forEach((back) => {
                back.addEventListener('click', function handleClick(this: HTMLElement) {
                    const closestMegaMenu = (back as HTMLElement).closest(".mega-menu");
                    if (closestMegaMenu) {
                        const tabSibling = closestMegaMenu.querySelector(".tab-sibling");
                        if (tabSibling) {
                            tabSibling.classList.remove('hide-menu');
                        }
                    }

                    const nameBack = this.getAttribute('data-back');
                    if (nameBack) {
                        const idWrap = document.getElementById(nameBack);
                        if (idWrap) {
                            idWrap.classList.remove('show-menu');
                            idWrap.classList.add('hide-menu');
                        }
                    }
                });
            });

            // Reset submenu on mouse leave
            const dynamicMenuWraps = document.querySelectorAll('.dynamic-menu-wrap');
            const newSubMegaMenus = document.querySelectorAll('.new-submenu-inner-warp > div');

            if (dynamicMenuWraps && window?.matchMedia("(min-width: 1024px)").matches) {
                dynamicMenuWraps.forEach(dynamicMenuWrap => {
                    dynamicMenuWrap.addEventListener('mouseleave', function () {
                        newSubMegaMenus.forEach((menu) => {
                            menu.classList.remove('show-menu');
                            menu.classList.add('hide-menu');
                        });

                        dynamicMenuWrap.classList.add('hide-menu');
                        dynamicMenuWrap.classList.remove('show-menu');

                        const mainMenu = document.querySelectorAll(".new-dynamic-menu .mega-inner-warp");
                        mainMenu?.forEach((menu) => {
                            menu.classList.remove('hide-menu');
                        });
                    });
                });
            }
        });
    }
}
/******************  NEW DYNAMIC MENU ENDS HERE ********************************/

/******************  NEW DYNAMIC MENU LARGE MEDIA TILE ************************/

function localDynamicMenuLargeMediaTile() {
    try {

        const serviceLargeMediaTile = (document.getElementById('servicelargemediatile') as HTMLInputElement)?.value;
        const franchiseWebLocationId = localStorage.getItem('franchiseWebLocationId');
        const dbaName = localStorage.getItem('dbaName');

        if (serviceLargeMediaTile && franchiseWebLocationId && dbaName) {
            const jsonData = JSON.parse(serviceLargeMediaTile);
            const jsonString = JSON.stringify(jsonData);
            
            const serviceLargeMediaTileApi = `${window.location.origin}/dynamicservicelargemediatiledata/${franchiseWebLocationId}/${dbaName}`;
            
            const request = {
                method: 'POST',
                url: serviceLargeMediaTileApi,
                data: { configJson: jsonString },
            };

            apiRequest(request).then((response: any) => {
                if (response) {
                    const serviceTileSection = document.querySelector('.service-tile-section');
                    if (serviceTileSection) {
                        serviceTileSection.outerHTML = response;
                    }
                    truncateTextWithEllipsis();
                }
            }).catch((error) => {
                console.error('Error in fetching dynamic service large media tile data:', error);
            });
        }
    } catch (error) {
        console.error('An error occurred in localDynamicMenuLargeMediaTile function:', error);
    }
}

/******************  END NEW DYNAMIC MENU LARGE MEDIA TILE ********************/

//Start of logic to handle Dynamic Menu Service Accordion Localised Header National Site //
export function dynamicMenuServiceAccordion() {
    try {
        const dynamicServiceAccordion = (document.getElementById('dynamicserviceaccordion') as HTMLInputElement)?.value;
        const webId: string | null = localStorage.getItem('weblocationId');
        const dbaName = localStorage.getItem('dbaName');
        let jsonData, jsonString;
        if (dynamicServiceAccordion && webId && dbaName && window.location.href.includes(dbaName)) {
            jsonData = JSON.parse(dynamicServiceAccordion);
            jsonString = JSON.stringify(jsonData);
            sessionStorage.setItem('dynamicAccorInfo', jsonString);
        }
        if (dynamicServiceAccordion && webId && dbaName && !window.location.href.includes(dbaName)) {
            const jsonStringAccor = sessionStorage.getItem('dynamicAccorInfo');
            const serviceAccordionApi = `${window.location.origin}/dynamicserviceaccordiondata/${webId}/${dbaName}`;

            const request = {
                method: 'POST',
                url: serviceAccordionApi,
                data: { configJson: jsonStringAccor },
            };

            apiRequest(request).then((response: any) => {
                if (!response) {
                    return;
                }

                const serviceTileSection = document.querySelector('.residential-block.dynamic-service-accordion');
                if (!serviceTileSection) { return };

                serviceTileSection.outerHTML = response;
                readMoreButton();
                // ReInitialize the accordion click functionality
                const serviceTileAccor = document.querySelector("#dynamic-accordion-service");
                if (!serviceTileAccor) { return };
                serviceTileAccor?.querySelectorAll("[data-accordion-target]").forEach((btn: any) => {
                    btn.addEventListener("click", () => {
                        const targetId = btn.getAttribute("data-accordion-target");
                        if (!targetId) return;
                        const targetElement = document.querySelector(targetId);
                        if (!targetElement) return;
                        const isExpanded = btn.getAttribute("aria-expanded") === "true";

                        document.querySelectorAll<HTMLButtonElement>(".list-accordion-btn").forEach(btn => {
                            btn.setAttribute("aria-expanded", "false");
                        });

                        // Toggle the clicked accordion
                        if (targetElement) {
                            targetElement.classList.toggle("hidden", isExpanded);
                            btn.setAttribute("aria-expanded", String(!isExpanded));
                        }
                    });
                });

            }).catch((error) => {
                console.error('Error in fetching dynamic service accordion data:', error);
            });
        }
    } catch (error) {
        console.error('An error occurred in dynamic service accordion function:', error);
    }
}

//End//

//Start dynamic menu scroll//
export function dynamicScroll() {
    //  Stop default browser behavior from jumping to hash
    if (window.location.hash) {
        history.scrollRestoration = "manual"; // prevents browser auto-scroll
        document.documentElement.style.scrollBehavior = "auto"; // Temporarily disable smooth scrolling
        window.scrollTo(0, 0); // Force reset to top
    }
 
    //  Handle smooth scrolling after page completely loads
    window.addEventListener("DOMContentLoaded", () => {
        if (window.location.hash) {
            requestAnimationFrame(scrollToHash);
        }
    });

    // Handling smooth scroll when browser url is selected and enter key is pressed
    window.addEventListener("popstate", () => {
        if (window.location.hash) {
        requestAnimationFrame(scrollToHash);
        }
    });
 
    //  Function to smoothly scroll to the target element
    const scrollToHash = (): void => {
        const hash = window.location.hash;
        if (!hash) return;
        const targetElement = document.querySelector(decodeURIComponent(hash));
        if (!targetElement) return;
 
        // Function to get header height
        const getHeaderHeight = (): number => {
            const header = document.querySelector(".second-head") as HTMLElement;
            return header ? header.offsetHeight : 0;
        };
 
        // Ensure the header is fully loaded before scrolling
        const waitForHeader = (callback: () => void) => {
            const checkHeader = () => {
                const header = document.querySelector(".second-head");
                if ((header as HTMLElement) && (header as HTMLElement)?.offsetHeight > 0) {
                    callback();
                } else {
                    requestAnimationFrame(checkHeader);
                }
            };
            checkHeader();
        };
 
        waitForHeader(() => {
            const headerHeight = getHeaderHeight();
            const targetPosition = (targetElement as HTMLElement).offsetTop;
            requestAnimationFrame(() => {
                document.documentElement.style.scrollBehavior = "smooth";
                window.scrollTo({
                    top: targetPosition - headerHeight - 10,
                    behavior: "smooth"
                });
            });
        });
    }
}

/******************  START NEW DYNAMIC MENU LARGE 25/75 MEDIA TILE 25/75 ************************/
export function localDynamicMenuLarge2575MediaTile() {
    try {
        const serviceLargeMediaTile = (document.getElementById('replacementblockdynamic') as HTMLInputElement)?.value;
        const franchiseWebLocationId = localStorage.getItem('franchiseWebLocationId');
        const dbaName = localStorage.getItem('dbaName');
        if (serviceLargeMediaTile && franchiseWebLocationId && dbaName) {
            const decodedValue:any = new DOMParser().parseFromString(serviceLargeMediaTile, "text/html").body.textContent;
            const jsonData = JSON.parse(decodedValue);
            const jsonString = JSON.stringify(jsonData);
            
            const serviceLargeMediaTileApi = `${window.location.origin}/dynamicservicemediatextlistdata/${franchiseWebLocationId}/${dbaName}`;
            
            const request = {
                method: 'POST',
                url: serviceLargeMediaTileApi,
                data: { configJson: jsonString },
            };
            apiRequest(request).then((response: any) => {
                if (response) {
                    const serviceTileSection = document.querySelector('.replacement-block');
                    if (serviceTileSection) {
                        serviceTileSection.outerHTML = response;
                    }
                    truncateTextWithEllipsis();
                }
            }).catch((error) => {
                console.warn('Error in fetching dynamic service large media tile data:', error);
            });
        } else {
            console.warn('Required values are missing from localStorage');
        }
    } catch (error) {
        console.warn('An error occurred in localDynamicMenuLarge2575MediaTile function:', error);
    }
}
/******************  END NEW DYNAMIC MENU LARGE 25/75 MEDIA TILE 25/75 ********************/

/***************** WHY CHOOSE US SECTION MORE TEXT JS STARTS HERE *************************/
document.addEventListener("DOMContentLoaded", () => {
    const maxChars: number = 160;
    const subtexts: NodeListOf<HTMLElement> = document.querySelectorAll(".more-text");

    if (!subtexts.length) return;

    subtexts.forEach((subtext) => {
        const fullText: string | undefined = subtext.textContent?.trim();
        if (!fullText || fullText.length <= maxChars) return;

        subtext.innerHTML = `${fullText.substring(0, maxChars)}... <span style="color:blue;cursor:pointer" class="toggle">Read More</span>`;

        const toggleButton = subtext.querySelector<HTMLElement>(".toggle");
        toggleButton?.addEventListener("click", () => {
            subtext.textContent = fullText;
        });
    });
});

/***************** WHY CHOOSE US SECTION MORE TEXT JS END HERE *************************/

/**************** START SMOOTH SCROLLING *********************/

document.addEventListener("DOMContentLoaded", () => {
    const hash = window.location.hash;
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
})
/**************** END SMOOTH SCROLLING *********************/
